// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__pRKJA","label":"LabeledBox_label__3sSMG"};